// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos Globales */
body, html {
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;
  font-family: 'Montserrat', sans-serif;
  overflow: hidden;
}

/* Diseño predeterminado para pantallas grandes con barra lateral */
.kyc-final-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 300px); /* Ajuste para la barra lateral en pantallas grandes */
  height: 100%;
  margin-left: 300px;
  padding: 1rem;
  box-sizing: border-box;
}

/* Estilo de la caja principal */
.kyc-box {
  background-color: var(--color-bg-dark) !important; /* Fondo azul oscuro */
  border: 2px solid var(--color-primary) !important; /* Borde naranja */
  width: 100% !important;
  max-width: 600px !important;
  padding: var(--spacing-6) !important;
  border-radius: var(--spacing-2) !important;
  color: var(--color-text-white) !important;
  text-align: center !important;
  box-shadow: 0px 4px 8px var(--color-shadow-medium) !important;
  margin: 0 auto !important;
}

/* Título (H1) */
h1 {
  font-size: var(--font-size-xl) !important;
  font-weight: var(--font-weight-medium) !important;
  margin-bottom: var(--spacing-4) !important;
  line-height: var(--line-height-dense) !important;
}

/* Subtítulo (H2) */
h2 {
  font-size: var(--font-size-base) !important;
  font-weight: var(--font-weight-normal) !important;
  margin-bottom: var(--spacing-6) !important;
  line-height: var(--line-height-normal) !important;
  color: var(--color-text-white) !important;
}

/* Estilos del botón */
.btn-outline-warning {
  background-color: transparent !important;
  border: 2px solid var(--color-text-white) !important;
  color: var(--color-text-white) !important;
  padding: var(--spacing-2) var(--spacing-4) !important;
  font-size: var(--font-size-base) !important;
  font-weight: var(--font-weight-semibold) !important;
  border-radius: var(--spacing-1) !important;
  cursor: pointer !important;
}

/* Efecto hover del botón */
.btn-outline-warning:hover {
  background-color: var(--color-primary-hover) !important;
  color: var(--color-text-white) !important;
  border: 2px solid var(--color-text-white) !important;
}

/* Enlace de contacto sin subrayado */
.contact-support {
  margin-top: var(--spacing-6) !important;
  font-size: var(--font-size-sm) !important;
}

.contact-support a {
  color: var(--color-text-white) !important;
  text-decoration: none !important;
}

.contact-support a:hover {
  color: var(--color-primary-hover) !important;
}

/* Media Queries */

/* Para pantallas de 1237px y menores, elimina la barra lateral y ajusta el ancho */
@media (max-width: 1237px) {
  .kyc-final-container {
    width: 100%;
    margin-left: 0;
    justify-content: center;
    padding: 1rem;
  }
}

/* Ajuste específico para iPad Pro, iPad Mini y Surface Pro (1024px y menores) */
@media (max-width: 1024px) {
  .kyc-final-container {
    width: 100%;
    margin-left: 6.5rem; 
    padding: 1.5rem;
    justify-content: center; 
  }
  .kyc-box {
    max-width: 550px;
  }
  h1 {
    font-size: 1.5rem;
  }
  h2 {
    font-size: 0.9rem;
  }
}

/* Para tablets pequeñas y dispositivos como Surface Go (900px y menores) */
@media (max-width: 912px) {
  .kyc-final-container {
    width: 100%;
    margin-left: 4rem;
    padding: 1.5rem;
    justify-content: center;
  }
  .kyc-box {
    max-width: 500px;
  }
  h1 {
    font-size: 1.4rem;
  }
  h2 {
    font-size: 0.85rem;
  }
}

@media (max-width: 820px) {
  .kyc-final-container {
    width: 100%;
    margin-left: 3rem;
    padding: 1.5rem;
    justify-content: center;
  }
  .kyc-box {
    max-width: 500px;
  }
  h1 {
    font-size: 1.4rem;
  }
  h2 {
    font-size: 0.85rem;
  }
}

/* Para tablets y teléfonos grandes (768px y menores) */
@media (max-width: 768px) {
  .kyc-final-container {
    width: 100%;
    margin-left: 2rem;
    padding: 1.25rem;
    justify-content: center;
  }
  .kyc-box {
    max-width: 450px;
  }
  h1 {
    font-size: 1.3rem;
  }
  h2 {
    font-size: 0.8rem;
  }
}

/* Para teléfonos medianos y pequeños (600px y menores) */
@media (max-width: 600px) {
  .kyc-final-container {
    width: 100%;
    margin-left: 2rem;
    padding: 1rem;
    justify-content: center;
  }
  .kyc-box {
    max-width: 400px;
    padding: 1.5rem;
  }
  h1 {
    font-size: 1.2rem;
  }
  h2 {
    font-size: 0.75rem;
  }
  .btn-outline-warning {
    font-size: 0.9rem;
    padding: 0.4rem 0.8rem;
  }
}

/* Para teléfonos muy pequeños (480px y menores) */
@media (max-width: 480px) {
  .kyc-final-container {
    width: 100%;
    margin-left: 0;
    padding: 1rem;
    justify-content: center;
  }
  .kyc-box {
    max-width: 350px;
    padding: 1.25rem;
  }
  h1 {
    font-size: 1.1rem;
  }
  h2 {
    font-size: 0.7rem;
  }
  .btn-outline-warning {
    font-size: 0.85rem;
    padding: 0.3rem 0.7rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/kyc-final/kyc-final.component.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB,EAAE,sDAAsD;EACjF,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,iDAAiD,EAAE,sBAAsB;EACzE,iDAAiD,EAAE,kBAAkB;EACrE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;EACpC,0CAA0C;EAC1C,yCAAyC;EACzC,6BAA6B;EAC7B,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,yCAAyC;EACzC,iDAAiD;EACjD,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA,mBAAmB;AACnB;EACE,2CAA2C;EAC3C,iDAAiD;EACjD,0CAA0C;EAC1C,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,wCAAwC;EACxC,oDAAoD;EACpD,yCAAyC;EACzC,qDAAqD;EACrD,2CAA2C;EAC3C,mDAAmD;EACnD,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,uDAAuD;EACvD,yCAAyC;EACzC,oDAAoD;AACtD;;AAEA,qCAAqC;AACrC;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,kBAAkB;;AAElB,mFAAmF;AACnF;EACE;IACE,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,aAAa;EACf;AACF;;AAEA,gFAAgF;AAChF;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,2EAA2E;AAC3E;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,uDAAuD;AACvD;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,yDAAyD;AACzD;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,WAAW;IACX,cAAc;IACd,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF","sourcesContent":["/* Estilos Globales */\nbody, html {\n  margin: 0;\n  padding: 0;\n  height: 100vh;\n  width: 100vw;\n  font-family: 'Montserrat', sans-serif;\n  overflow: hidden;\n}\n\n/* Diseño predeterminado para pantallas grandes con barra lateral */\n.kyc-final-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: calc(100% - 300px); /* Ajuste para la barra lateral en pantallas grandes */\n  height: 100%;\n  margin-left: 300px;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n/* Estilo de la caja principal */\n.kyc-box {\n  background-color: var(--color-bg-dark) !important; /* Fondo azul oscuro */\n  border: 2px solid var(--color-primary) !important; /* Borde naranja */\n  width: 100% !important;\n  max-width: 600px !important;\n  padding: var(--spacing-6) !important;\n  border-radius: var(--spacing-2) !important;\n  color: var(--color-text-white) !important;\n  text-align: center !important;\n  box-shadow: 0px 4px 8px var(--color-shadow-medium) !important;\n  margin: 0 auto !important;\n}\n\n/* Título (H1) */\nh1 {\n  font-size: var(--font-size-xl) !important;\n  font-weight: var(--font-weight-medium) !important;\n  margin-bottom: var(--spacing-4) !important;\n  line-height: var(--line-height-dense) !important;\n}\n\n/* Subtítulo (H2) */\nh2 {\n  font-size: var(--font-size-base) !important;\n  font-weight: var(--font-weight-normal) !important;\n  margin-bottom: var(--spacing-6) !important;\n  line-height: var(--line-height-normal) !important;\n  color: var(--color-text-white) !important;\n}\n\n/* Estilos del botón */\n.btn-outline-warning {\n  background-color: transparent !important;\n  border: 2px solid var(--color-text-white) !important;\n  color: var(--color-text-white) !important;\n  padding: var(--spacing-2) var(--spacing-4) !important;\n  font-size: var(--font-size-base) !important;\n  font-weight: var(--font-weight-semibold) !important;\n  border-radius: var(--spacing-1) !important;\n  cursor: pointer !important;\n}\n\n/* Efecto hover del botón */\n.btn-outline-warning:hover {\n  background-color: var(--color-primary-hover) !important;\n  color: var(--color-text-white) !important;\n  border: 2px solid var(--color-text-white) !important;\n}\n\n/* Enlace de contacto sin subrayado */\n.contact-support {\n  margin-top: var(--spacing-6) !important;\n  font-size: var(--font-size-sm) !important;\n}\n\n.contact-support a {\n  color: var(--color-text-white) !important;\n  text-decoration: none !important;\n}\n\n.contact-support a:hover {\n  color: var(--color-primary-hover) !important;\n}\n\n/* Media Queries */\n\n/* Para pantallas de 1237px y menores, elimina la barra lateral y ajusta el ancho */\n@media (max-width: 1237px) {\n  .kyc-final-container {\n    width: 100%;\n    margin-left: 0;\n    justify-content: center;\n    padding: 1rem;\n  }\n}\n\n/* Ajuste específico para iPad Pro, iPad Mini y Surface Pro (1024px y menores) */\n@media (max-width: 1024px) {\n  .kyc-final-container {\n    width: 100%;\n    margin-left: 6.5rem; \n    padding: 1.5rem;\n    justify-content: center; \n  }\n  .kyc-box {\n    max-width: 550px;\n  }\n  h1 {\n    font-size: 1.5rem;\n  }\n  h2 {\n    font-size: 0.9rem;\n  }\n}\n\n/* Para tablets pequeñas y dispositivos como Surface Go (900px y menores) */\n@media (max-width: 912px) {\n  .kyc-final-container {\n    width: 100%;\n    margin-left: 4rem;\n    padding: 1.5rem;\n    justify-content: center;\n  }\n  .kyc-box {\n    max-width: 500px;\n  }\n  h1 {\n    font-size: 1.4rem;\n  }\n  h2 {\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 820px) {\n  .kyc-final-container {\n    width: 100%;\n    margin-left: 3rem;\n    padding: 1.5rem;\n    justify-content: center;\n  }\n  .kyc-box {\n    max-width: 500px;\n  }\n  h1 {\n    font-size: 1.4rem;\n  }\n  h2 {\n    font-size: 0.85rem;\n  }\n}\n\n/* Para tablets y teléfonos grandes (768px y menores) */\n@media (max-width: 768px) {\n  .kyc-final-container {\n    width: 100%;\n    margin-left: 2rem;\n    padding: 1.25rem;\n    justify-content: center;\n  }\n  .kyc-box {\n    max-width: 450px;\n  }\n  h1 {\n    font-size: 1.3rem;\n  }\n  h2 {\n    font-size: 0.8rem;\n  }\n}\n\n/* Para teléfonos medianos y pequeños (600px y menores) */\n@media (max-width: 600px) {\n  .kyc-final-container {\n    width: 100%;\n    margin-left: 2rem;\n    padding: 1rem;\n    justify-content: center;\n  }\n  .kyc-box {\n    max-width: 400px;\n    padding: 1.5rem;\n  }\n  h1 {\n    font-size: 1.2rem;\n  }\n  h2 {\n    font-size: 0.75rem;\n  }\n  .btn-outline-warning {\n    font-size: 0.9rem;\n    padding: 0.4rem 0.8rem;\n  }\n}\n\n/* Para teléfonos muy pequeños (480px y menores) */\n@media (max-width: 480px) {\n  .kyc-final-container {\n    width: 100%;\n    margin-left: 0;\n    padding: 1rem;\n    justify-content: center;\n  }\n  .kyc-box {\n    max-width: 350px;\n    padding: 1.25rem;\n  }\n  h1 {\n    font-size: 1.1rem;\n  }\n  h2 {\n    font-size: 0.7rem;\n  }\n  .btn-outline-warning {\n    font-size: 0.85rem;\n    padding: 0.3rem 0.7rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
